import request from './../common/request'
import { getToken, setToken } from "./../views/common";

let url = 'https://marketing.chuanbaoguancha.cn/v1'


//获取排行榜
export function rank() {
	return new Promise((resolve, reject) => {
		request({
			method: 'get',
			url: `${url}/common/olympic/rank`,
			headers: {
				Authorization: 'Bearer ' + getToken().token
			}
		}).then(resp => {
			resolve(resp);
		}).catch((resp) => {
			console.log('in api error')
			console.log(resp)
			reject(resp)
		})
	})

}

//列表
export function list(page) {
	return new Promise((resolve, reject) => {
		request({
			method: 'get',
			url: `${url}/common/olympic/list?page=${page}`,
			headers: {
				Authorization: 'Bearer ' + getToken().token
			}
		}).then(resp => {
			resolve(resp);
		}).catch((resp) => {
			reject(resp)
		})
	})
}

//竞猜倍率
export function rate(id) {
	return new Promise((resolve, reject) => {
		request({
			method: 'get',
			url: `${url}/common/olympic/guessing?id=${id}`,
			headers: {
				Authorization: 'Bearer ' + getToken().token
			}
		}).then(resp => {
			resolve(resp);
		}).catch((resp) => {
			reject(resp)
		})
	})
}


//竞猜
export function guessing(id, magnify, score, guessing_result) {
	let sign = ("magnify=" + magnify + "&id=" + id + "&guessing_result=" + guessing_result + "&score=" + score + "0wxesg6sm4u8x5b9" + parseInt((new Date()).getTime() / 1000)).MD5(32)
	console.log(("magnify=" + magnify + "&id=" + id + "&guessing_result=" + guessing_result + "&score=" + score + "0wxesg6sm4u8x5b9" + parseInt((new Date()).getTime() / 1000)),sign)
	return new Promise((resolve, reject) => {
		request({
			method: 'post',
			url: `${url}/common/olympic/guessing`,
			data: {
				id, magnify, score, guessing_result, sign
			},
			headers: {
				Authorization: 'Bearer ' + getToken().token
			}
		}).then(resp => {
			resolve(resp);
		}).catch((resp) => {
			reject(resp)
		})
	})
}

//获取token、昵称、头像
export function authLogin(res) {
	console.log(res)
	return new Promise((resolve, reject) => {
		request({
			method: 'post',
			url: `${url}/auth/cbgc`,
			data: res,
		}).then(resp => {
			setToken({
				token: resp.data.meta.custom.access_token,
				avatar: resp.data.data.avatar,
				nickname: resp.data.data.nickname
			})
			resolve(resp);
		}).catch((resp) => {
			reject(resp)
		})

	})
}

